// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"97c7cc32","390":"3e3102d3","751":"97c7cc32"}[chunkId] + ".chunk.js";
};